import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DialogContentComponent } from './components/dialog-content/dialog-content.component';
import { DialogFooterComponent } from './components/dialog-footer/dialog-footer.component';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';

@NgModule({
  imports: [DialogHeaderComponent, DialogContentComponent, DialogFooterComponent, ConfirmationDialogComponent],
  exports: [MatDialogModule, DialogHeaderComponent, DialogContentComponent, DialogFooterComponent, ConfirmationDialogComponent],
})
export class SharedDialogsModule {}
